import { apiFetch } from "../http";
const getErrorMessage = (data, fallback) => {
    if (!data)
        return fallback;
    if (typeof data.errors === "string")
        return data.errors;
    if (data.errors && typeof data.errors === "object") {
        return Object.values(data.errors).join(", ");
    }
    return data.error || data.detail || data.message || fallback;
};
export async function sendAdminSystemMessage(params) {
    var _a, _b;
    const normalizedTitle = String((_a = params.payload.title) !== null && _a !== void 0 ? _a : "").trim();
    const normalizedText = String((_b = params.payload.text) !== null && _b !== void 0 ? _b : "").trim();
    const normalizedUserIds = Array.isArray(params.payload.user_ids)
        ? params.payload.user_ids.map((value) => String(value !== null && value !== void 0 ? value : "").trim()).filter(Boolean)
        : [];
    const body = {
        title: normalizedTitle,
        text: normalizedText,
        send_to_all: Boolean(params.payload.send_to_all),
        ...(params.payload.send_in_app !== undefined ? { send_in_app: params.payload.send_in_app } : {}),
        ...(params.payload.send_email !== undefined ? { send_email: params.payload.send_email } : {}),
        ...(params.payload.audience ? { audience: params.payload.audience } : {}),
        ...(normalizedUserIds.length > 0 ? { user_ids: normalizedUserIds } : {}),
        ...(params.payload.expires_at ? { expires_at: params.payload.expires_at } : {}),
    };
    const data = await apiFetch(`/user/api/admin/system-messages/send/`, {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false) {
        throw new Error(getErrorMessage(data, "Не удалось отправить системное сообщение"));
    }
    return data;
}
export async function previewAdminSystemMessage(params) {
    return apiFetch(`/user/api/admin/system-messages/preview/`, {
        baseUrl: params.baseUrl, token: params.token, method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ title: params.title, text: params.text }),
    });
}
export async function getAdminSystemMessages(params) {
    const data = await apiFetch(`/user/api/admin/system-messages/`, {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "GET",
        headers: { Accept: "application/json" },
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false) {
        throw new Error(getErrorMessage(data, "Не удалось загрузить системные сообщения"));
    }
    return data;
}
export async function deleteAdminSystemMessage(params) {
    const data = await apiFetch(`/user/api/admin/system-messages/${encodeURIComponent(String(params.messageId))}/`, {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "DELETE",
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false) {
        throw new Error(getErrorMessage(data, "Не удалось удалить системное сообщение"));
    }
    return data;
}
